
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/[slug]",
      function () {
        return require("private-next-pages/platform/[slug].js");
      }
    ]);
  